routing.$inject = ['$urlRouterProvider', '$locationProvider'];

export default function routing($urlRouterProvider, $locationProvider) {
  if (window.history && window.history.pushState) {
    $locationProvider.html5Mode(true);
  }
  else if (window.location.hash.length === 0) {
    window.location.hash = window.location.pathname; // IE 9 FIX
  }
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/base.config.js
 **/